import { h, resolveComponent, type VNode } from 'vue';
interface TeamsListRow {
  needs_attention: boolean;
  team_name?: string | null;
}

type RowProcessFunction<T extends TeamsListRow> = (row: T) => VNode;

export function useTeamsList<T extends TeamsListRow>() {
  const renderNeedAttentionIcon: RowProcessFunction<T> = (row) => {
    return (row.needs_attention 
      ? h(
        resolveComponent('ui-icon'), 
        {
          name: 'exclamation-circle',
          color: 'var(--text-negative)',
        },
      ) 
      : h('span', {}, ''));
  };

  const appendTeam: RowProcessFunction<T> = (row) => {
    if (row.team_name) {
      return h('span', [row.team_name]);
    }
    return h('span', '—');
  };

  return {
    renderNeedAttentionIcon,
    appendTeam,
  }
}
